/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Error from '../model/Error';
import GenerateVoucherResponse from '../model/GenerateVoucherResponse';

/**
* StudentAcademicProgramsMad service.
* @module api/StudentAcademicProgramsMadApi
* @version 1.0
*/
export default class StudentAcademicProgramsMadApi {

    /**
    * Constructs a new StudentAcademicProgramsMadApi. 
    * @alias module:api/StudentAcademicProgramsMadApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Generar voucher (Madrid)
     * @param {Number} studentId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.academicProgramId 
     * @param {String} opts.voucherType 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GenerateVoucherResponse} and HTTP response
     */
    studentAcademicProgramMadControllerGenerateVoucherWithHttpInfo(studentId, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling studentAcademicProgramMadControllerGenerateVoucher");
      }

      let pathParams = {
        'student_id': studentId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'academic_program_id': opts['academicProgramId'],
        'voucher_type': opts['voucherType']
      };

      let authNames = ['BearerAuth'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = GenerateVoucherResponse;
      return this.apiClient.callApi(
        '/student-academic-programs-title/students/{student_id}/generate-voucher/mad', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Generar voucher (Madrid)
     * @param {Number} studentId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.academicProgramId 
     * @param {String} opts.voucherType 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GenerateVoucherResponse}
     */
    studentAcademicProgramMadControllerGenerateVoucher(studentId, opts) {
      return this.studentAcademicProgramMadControllerGenerateVoucherWithHttpInfo(studentId, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
